module.exports = "/_next/static/images/location-marker-new-9d1d6e697f96ee29ec395592fde5d2f0.png";